angular.module('qbePortal').controller('PlaneController', [
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'$window',
	'userInputRepository',
	'serviceResponseRepository',
	'quoteOptions',
	'paymentService',
	'quoteModelFactory',
	'dynamicRouter',
	'portalServiceWrapper',
	'MAService',
	'labelService',
	'Util',
	'$q',
	'storage',
	'jwtHelper',
	'gtmService',
	'quoteRequestRepository',
	'MODULE_INFO',
	function ($rootScope, $scope, $state, $stateParams, $window, userInputRepository, serviceResponseRepository, quoteOptions, paymentService, quoteModelFactory, dynamicRouter, portalServiceWrapper, MAService, labelService, util, $q, storage, jwtHelper, gtmService, quoteRequestRepository, MODULE_INFO) {
		var $ctrl = this;
		$rootScope.$broadcast('loading-animation-end');

		/** 
		* routing initialisation, enabling/disabling (hiding/showing) available routes
		* testing for allowed routes and redirecting when not allowed
		*/
		function markCompletedRouteCallback(stateName){
			storage.setItem('completed-step', stateName);
		}

		function initialiseRouting(){
			dynamicRouter.initialise($state.current.name, $state.$current.parent.name, null, markCompletedRouteCallback);
			$ctrl.title = dynamicRouter.getPageTitle();
			$ctrl.steps = dynamicRouter.getSteps();
		}
		/** End of routing logic */
		
		$ctrl.state = $state;
		$ctrl.storage = storage;
		$ctrl.sections = {};
		$ctrl.moduleId = MODULE_INFO.id ;

		$ctrl.cybersourceiFrameUrl = $state.href('cybersourcePaymentForm', null, {absolute: true});
		$ctrl.addCybersourceiFrame = false ; 
		$ctrl.summaryModel = quoteModelFactory.create();

		function getDefaultValues() {
			return {
				fromFullQuote: true,
				paymentForm: {
					paymentDetails :{
						paymentOptions: 'yearly'
					}
				}
			};
		}

		function scrollViewTo($element) {
			var offset = $element.offset();
			if ( offset ) {
				$('html, body').animate({
					scrollTop: (offset.top - 50),
					scrollLeft: offset.left
				});
			}
		}

		/**
		* QbFormSections register themselves with the form controller.
		* This is done automatically by the form section upon initialisation.
		* @name : name of the form section
		* @init : function callback initialise the section
		* @getValueFn: function callback to get the value of the section.
		*/
		$ctrl.registerSection = function (name, init, getValueFn) {
			$ctrl.sections[name] = {
				initValue: init,
				getValue: getValueFn
			};
		}

		/**
		* Any generic breaking errors should broadcast 'error' to the rootScope. This will cause redirection
		* to the main error page.
		*/
		$scope.$on('error', function(event, error) {
			$state.go('error', error);
		});

		/**
		* calls MA Services to add marketing data.
		*/
		$scope.$on('perform-ma-service', function(event, triggeredBy) {
			performMAServices(triggeredBy) ;
		});

		$scope.$on('back', function () {
			gtmService.trackEvent('back') ;
			$ctrl.back()
		});

		/**
		* called from qbFormSection and any other panel that requires a requote based on new values.
		*/
		$scope.$on('requote', function(event, page) {
			gtmService.trackEvent('requote') ;
			$rootScope.$broadcast('loading-animation-start');
			var formData = getUserInput();
			getRequote(formData, page, function(resp) {
				$rootScope.$broadcast('loading-animation-end');
				$rootScope.$broadcast('quote-received', resp);
				$rootScope.$broadcast('selected-quote-changed') ;
			});
		});

		function getUserInput() {
			var formData = getFormInput() ;
			userInputRepository.update(formData);
			return userInputRepository.get(getDefaultValues());
		}

		function getFormInput() {
			var formData = {};
			for (var key in $ctrl.sections) {
				formData[key] = $ctrl.sections[key].getValue();
			}
			return formData;
		}

		function getRequote(formData, page, callback) {
			portalServiceWrapper.updateQuote(formData);
			var requoteOptions = quoteOptions.getRequoteOptions(MODULE_INFO.paymentPageRouteName);
			if ( requoteOptions ) {
				portalServiceWrapper
					.getQuickQuote(requoteOptions.permutations, requoteOptions.rules).then(function(resp) {
						if (callback )
							callback(resp) ;
					})
					.catch(function(err) {
						console.log(err) ;
						broadcastError(err, 'Requote error');
					});
			} else {
				return false ;
			}
			return true;
		}

		$ctrl.save = function () {
			$rootScope.$broadcast('open-modal', { modal: 'saveQuote' });
		};

		$ctrl.back = function () {
			gtmService.trackEvent('back') ;
			$scope.$broadcast('reset-field-errors');
			var backState = dynamicRouter.back();
			if ( backState )
				$state.go(backState);
			else {
				var formData = getUserInput() ;
				if ( formData.rapidEstimateUrl )
					window.location.href = formData.rapidEstimateUrl ;
			}
		};

		$ctrl.submit = function (form) {
			gtmService.trackEvent('next') ;
			$ctrl.showErrorSummary = false;
			if (form.$invalid) {
				$scope.$broadcast('broadcast-field-errors');
				$ctrl.showErrorSummary = true;
				$scope.$broadcast('reset-field-errors');
				scrollViewTo($('#combinedValidationListing')) ;
				return;
			}

			processPayment(form) ;
		};

		function performMAServices(eventName) {
			getUserInput() ;
			var mainPolicyHolder = userInputRepository.get({}, 'caravanForm.mainPolicyHolder');
			var policyEmail = userInputRepository.get({}, 'email') ;
			var quoteResult = quoteOptions.getSelectedQuoteResult();
			var savedQuote = serviceResponseRepository.getLastResponseFrom('quote') ;
			var maData = {
				pageName: $state.current.name,
				mainPolicyHolder: mainPolicyHolder,
				policyEmail: policyEmail,
				annualResult: quoteResult.getAnnual(),
				monthlyResult: quoteResult.getMonthly(),
				quoteId : savedQuote ? savedQuote.quoteID : null,
			};
			MAService.mergeContacts(eventName, maData) ;
		}

		function processPayment(form) {
			formData = getUserInput();

			var paymentDetailsForm = form.paymentDetails;

			userInputRepository.update(formData);

			$rootScope.$broadcast('loading-animation-start');
			switch (formData.paymentForm.paymentDetails.paymentMethod) {
				case 'creditcard':
					payByCreditCard(formData, paymentDetailsForm);
					break;
				case 'paypal':
					// handled by qbFormSection.directive.payByPaypal()
					break;
				case 'bankaccount':
					payByDirectDebit(formData);
					break;
			}
		}

		function payByCreditCard(formData, form) {
			paymentService.payByCreditCard(
				// pass credit card data
				{
					cardNumber: formData.paymentForm.paymentDetails.cardNumber,
					cardHolderName: formData.paymentForm.paymentDetails.cardHolderName,
					cvc: formData.paymentForm.paymentDetails.cardCvc,
					type: form.cardNumber.$ccType,
					cardExpiryDate: formData.paymentForm.paymentDetails.cardExpiryDate
				},
				// on successfully calling the Create Creditcard Payment service
				function (creditCardPaymentData) {
					// make the scope available globally. This data will be used by the iFrame to construct the form that will post to Cybersource
					$window.$controllerScope = $scope;
					// set the data to send to Cybersource to the scope
					$scope.creditCardPaymentData = creditCardPaymentData;
					// set the URL for the iFrame to the Cybersource Payment Form (which will use the `creditCardPaymentData`) to generate and submit the form
					$ctrl.addCybersourceiFrame = true ; 
				},
				// on error
				function (errorResponse) {
					console.error(errorResponse);
					$state.go('error');
				}
			);
		}

		function payByDirectDebit(formData) {
			paymentService.payByDirectDebit(
				// pass bank account data
				{
					bsb: formData.paymentForm.paymentDetails.bsb,
					accountNumber: formData.paymentForm.paymentDetails.accountNumber,
					accountName: formData.paymentForm.paymentDetails.accountName
				},
				// on successfully calling the Create Direct Debit Payment service
				function (directDebitPaymentData) {
					$scope.onPaymentCallback(true, directDebitPaymentData);
				},
				// on error
				function (errorResponse) {
					console.error(errorResponse);
					$state.go('error');
				}
			);
		}


		/**
		 * Initialisation method of the payment page
		 */
		$ctrl.initPaymentPage = function () {
			initialiseRouting();
			
			util.dispatchCustomEvent('register-labels');
			$ctrl.termsAndConditions = false;
			var formData = getUserInput();
			formData.paymentForm.paymentDetails.termsAndConditions = false ;
			quoteOptions.setSelectedPaymentFrequency(formData.paymentForm.paymentDetails.paymentOptions) ;
			$ctrl.formData = formData ;
			getRequote(formData);
			$scope.$on('payment-method-changed', function(event, paymentMethod) {
				$ctrl.paymentMethod = paymentMethod;
			});
			$scope.$on('terms-and-conditions-changed', function(event, termsAndConditions) {
				$ctrl.termsAndConditions = termsAndConditions;
			});
		}


		/**
		 * This callback is called from the iFrame when the response is received from the GuideWire payment service
		 * @param success
		 * @param stateParams
		 */
		$scope.onPaymentCallback = function (success, params) {
			$rootScope.$broadcast('loading-animation-end');

			if (success) {
				var confirmationData = {
					policyNumber: params.policyNumber,
					accountNumber: params.accountNumber,
					isAwaitingProcess: params.status === 'AWAITING_PROCESS'
				};

				// Go to confirmation
				$state.go(MODULE_INFO.donePageRouteName, confirmationData);
				// console.log('Great success! Payment completed! Move to confirmation page', confirmationData);
			}else{
				//payment error - show error page
				$state.go('error');
			}

		}
	}]
);
